module.exports = __webpack_public_path__ + "img/1726043764958-screenshot-1726043586394.png.5991357c.webp";